import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Loader from '../../Components/Loader'
import noneImage from '../../assets/none-png-2.png'
import { Helmet } from 'react-helmet'
import Cast from '../../Components/Cast'
import CastProfile from '../../Components/CastProfile'
import { Route, NavLink, Redirect } from 'react-router-dom'
import Company from './Company/Company'
import Country from './Country/Country'
import Error from '../../Components/Error'
import Season from '../../Components/Season'
import Recommendations from '../../Components/Recommendations'


const Container = styled.div`
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    padding:70px;
    @media screen and (max-width:768px) {
        padding:0;
    }
`
const Backdrop = styled.div`
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:calc(100vh - 50px);
    background-image:url(${props => props.imgBg});
    background-position:center center;
    background-size:cover;
    filter:blur(3px);
    opacity:0.5;
    @media screen and (max-width:768px) {
        display:none;
    }
`

const Content = styled.div`
    display:flex;
    width: 100%;
    position:relative;
    z-index:1;
    height:100%;
    border-radius:5px;
    @media screen and (max-width:768px) {
        flex-direction:column;
        position: relative;
        width:100%;
    }
`

const Cover = styled.div`
    border-radius:5px;
    min-width:30%;
    margin-right:20px;
    background-image:url(${props => props.imgBg});
    background-position:center center;
    background-size:cover;
    height:100%;
    z-index:0;
    @media screen and (max-width:768px) {
        width:100%;
        margin:auto;
        z-index:-1;
        top:0;
        left:0;
        position:fixed;
        height:calc(100vh);
        z-index:-1;
        opacity:0.3
    }
`

const Data = styled.div`
    width:65%;
    height:100%;
    overflow: auto;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            background:rgba(0,0,0,0.1)
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.2);
    }
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(255,255,255,0.5);
    }
    margin-left:10px;
    @media screen and (max-width:768px) {
        padding-top:5%;
        width:90%;
        margin-left:0;
        margin:0 auto;
        overflow:unset;
    }
`

const Title = styled.h3`
    font-size:32px;
    @media screen and (max-width:768px) {
       font-size:23px;
       color:yellow;
    }
`

const ItemContainer = styled.div`
    margin:20px 0;
    @media screen and (max-width:768px) {
        width:90%;
       margin:15px 0 10px;
       overflow:hidden;
       text-overflow:ellipsis;
       white-space:nowrap;
    }
`

const Item = styled.span`

`

const Divider = styled.span`
    margin: 0 10px;
    @media screen and (max-width:768px) {
       margin:0 5px;
    }
`

const Overview = styled.p`
    font-size:18px;
    padding:5px 0 5px;
    opacity:0.7;
    line-height:1.5;
    width:95%;
    @media screen and (max-width:768px) {
       width:100%;
       font-size:14px;
    }

`
const IMDb = styled.span`
    font-size:18px;
    font-weight:700;
    margin-left:10px;
    padding:0 6px;
    text-align:center;
    vertical-align:center;
    border-radius:4px;
    color:black;
    background:#F5C518;
    @media screen and (max-width:768px){
        font-size:16px;
    }
`
const CastContainer = styled.div`
    padding:10px 0;
    margin:auto;
`
const VideoContainer = styled.iframe`
    position: relative;
    :first-child{
        margin-right:5px;
    }
    :not(:first-child){
    margin:0 5px; 
    }
    border-radius:5px;
    width:400px;
    height:170px;
    @media screen and (max-width:768px) {
        width:100%;
    }
`

const Media = styled.div`
    padding:10px 0;
    margin:auto;
    div{
        position:relative;
        display:flex;    
        overflow: auto;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            background:rgba(0,0,0,0.1)
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.2);
    }
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(255,255,255,0.5);
    }}
    p{
        padding:0 0 10px;
        font-size:14px;
        font-weight:600
    }
`
const ButtonContainer = styled.form`
    font-size:17px;
    color:white;
    width:100%;
    margin:auto;
    display:flex;
    @media screen and (max-width:768px){
    padding:5px 0 0;
    }
`
const ButtonLink = styled(NavLink)`
    padding:10px 10px;
    text-decoration:none;
    font-weight:600;
    font-size:20px;
    color:white;
    text-align:center;
    display:block;
    transition:0.2s linear;
    border-radius:10px 10px 0 0;
    &:hover{
        color:red;
        border-bottom:3px solid yellow
    }
    @media screen and (max-width:768px) {
        font-size:16px;

    }
`
const Foot = styled.div`
    display:none;
    @media screen and (max-width:768px) {
        display:block;
       height:20px;
    }
`

const DetailPresenter = ({ imdb_id, credits, result, error, loading, recommendations, type }) => {
    return (
        loading ? <Loader /> : error ? <Error data={'No Detail Data'} /> :
            <Container>
                <Helmet>
                    <title>
                        {result.original_title ? result.original_title : result.original_name} | Maflix
                    </title>
                </Helmet>
                <Backdrop imgBg={result.backdrop_path ? `https://image.tmdb.org/t/p/w500${result.backdrop_path}` : null} />
                <Content>
                    <Cover imgBg={result.poster_path ? `https://image.tmdb.org/t/p/original${result.poster_path}` : noneImage} />
                    <Data>
                        <Title>
                            {result.original_title ? result.original_title : result.original_name}
                            <IMDb>
                                {result.imdb_id ? <a href={`https://www.imdb.com/title/${result.imdb_id}`} rel='noopener noreferrer' target='_blank'>IMDB</a> : <a href={`https://www.imdb.com/title/${imdb_id}`} rel='noopener noreferrer' target='_blank'>IMDB</a>}
                            </IMDb>
                        </Title>
                        <ItemContainer>
                            <Item>{result.vote_average ? '⭐' + result.vote_average : null}</Item>
                            <Divider>▪</Divider>
                            <Item>{result.release_date ? result.release_date.substring(0, 4) : result.first_air_date.substring(0, 4)}</Item>
                            <Divider>▪</Divider>
                            <Item>{result.runtime ? result.runtime : result.episode_run_time ? result.episode_run_time[0] : null} min</Item>
                            <Divider>▪</Divider>
                            <Item>{result.genres && result.genres.map((i, index) => index === result.genres.length - 1 ? i.name : `${i.name} / `)}</Item>
                        </ItemContainer>
                        <Overview>
                            {result.overview && result.overview.length > 0 && result.overview}
                        </Overview>
                        <CastContainer>
                            {credits && credits.length > 0 && (
                                <Cast title={'Cast'}>{credits.map(i => <CastProfile char={i.character} key={i.id} id={i.id} imgUrl={i.profile_path} title={i.name} />)}</Cast>
                            )}
                        </CastContainer>
                        <Media>
                            <p>Trailer</p>
                            <div>
                                {result && result.videos.results.length > 0 &&
                                    result.videos.results.map(i =>
                                        i.site === 'YouTube' ?
                                            <VideoContainer
                                                id={i.id}
                                                key={i.id}
                                                title={i.id}
                                                src={`https://www.youtube.com/embed/${i.key}`}
                                                allowFullScreen='allowFullScreen'
                                                frameBorder='0'
                                            >
                                            </VideoContainer> : null)
                                }
                            </div>
                        </Media>
                        {type === "show" && result && result.seasons && result.seasons.length > 0 && (
                            <CastContainer>
                                <Cast title={'Seasons'}>{result.seasons.map(i => <Season season={i.season_number} key={i.id} id={result.id} imgUrl={i.poster_path} title={result.original_name} />)}</Cast>
                            </CastContainer>)}
                        {recommendations && recommendations.results && recommendations.results.length > 0 && (
                            <CastContainer>
                                <Cast title={'Recommendations'}>{recommendations.results.map(i => <Recommendations isMovie={type === 'movie' ? true : false} key={i.id} id={i.id} imgUrl={i.poster_path} title={i.name ? i.name : i.original_title} />)}</Cast>
                            </CastContainer>)}
                        <ButtonContainer>
                            <ButtonLink to={{ pathname: type === 'movie' ? `/movie/${result.id}/company/` : `/show/${result.id}/company/` }}
                                activeStyle={{
                                    background: "rgba(255,255,255,0.2)",
                                    color: "#F5C518",
                                    borderBottom: '3px solid #F5C518'
                                }}>Company</ButtonLink>
                            {type === 'movie' ?
                                <ButtonLink to={{ pathname: `/movie/${result.id}/country/` }}
                                    activeStyle={{
                                        background: "rgba(255,255,255,0.2)",
                                        color: "#F5C518",
                                        borderBottom: '3px solid #F5C518'
                                    }} >Country</ButtonLink>
                                : type === 'show' ?
                                    <ButtonLink to={{ pathname: `/show/${result.id}/country/` }}
                                        activeStyle={{
                                            background: "rgba(255,255,255,0.2)",
                                            color: "#F5C518",
                                            borderBottom: '3px solid #F5C518'
                                        }} >Network</ButtonLink> : null
                            }

                        </ButtonContainer>
                        <Route path={`/:type/:id/company/`} exact component={Company} />
                        <Route path={`/:type/:id/country/`} exact component={Country} />
                        <Redirect from={'*'} to={{ pathname: type === 'movie' ? `/movie/${result.id}/company/` : type === 'show' ? `/show/${result.id}/company/` : '/error' }} />
                        <Foot></Foot>
                    </Data>
                </Content>
            </Container >
    )
}

DetailPresenter.propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    result: PropTypes.object
}

export default DetailPresenter